import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexResponsive,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexYAxis,
  ChartComponent,
} from 'ng-apexcharts';

export {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexTitleSubtitle,
  ApexXAxis,
  ChartComponent,
};

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  plotOptions: ApexPlotOptions;
  title: ApexTitleSubtitle;
  responsive: ApexResponsive[];
};

@Component({
  selector: 'app-horizontal-bar-graph',
  templateUrl: './horizontal-bar-graph.component.html',
  styleUrls: ['../../../shared/analytics//analytics.scss'],
  encapsulation: ViewEncapsulation.None,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class HorizontalBarGraphComponent implements OnChanges {
  @ViewChild('chart') chart: ChartComponent;

  @Input() data: any[] = [];

  @Input() categories: string[] = [];

  @Input() chartName: string = '';

  @Output() changeDevice = new EventEmitter<string>();

  public chartOptions: ChartOptions;

  constructor() {
    this.chartOptions = {
      series: [],
      chart: {
        height: 350,
        type: 'bar',
        events: {
          dataPointSelection: (event, chartContext, config) => {
            this.onChangeDevice(config);
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -17,
        style: {
          colors: ['#000000'],
          fontSize: '11px',
          fontWeight: 'bold',
        },
        formatter: (value: number) => {
          if (this.chartName.includes('%')) {
            return `${value.toLocaleString('en-US')}%`;
          }
          return value.toLocaleString('en-US');
        },
      },
      xaxis: {
        categories: this.categories,
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            if (this.chartName.includes('%')) {
              return `${value.toLocaleString('en-US')}%`;
            }
            return value.toLocaleString('en-US');
          },
        },
      },
      title: {
        text: this.chartName,
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
      },
      responsive: [],
    };

    this.applyResponsiveOptions();
  }

  ngOnChanges(): void {
    // Update chart options when @Input properties change
    this.chartOptions.xaxis = { categories: this.categories };
    this.chartOptions.series = this.data;
    this.chartOptions.title.text = this.chartName;
    this.applyResponsiveOptions();
  }

  private applyResponsiveOptions() {
    this.chartOptions.responsive = [
      {
        breakpoint: 768,
        options: {
          chart: { toolbar: { show: false } },
          title: {
            text: this.chartName.includes('for')
              ? this.chartName.replace('for', '\nfor')
              : this.chartName,
            align: 'center',
            offsetY: 0,
          },
        },
      },
    ];
  }

  onChangeDevice(config: { dataPointIndex: number }): void {
    const selectedPointIndex = config.dataPointIndex;
    this.changeDevice.emit(
      this.chartOptions.xaxis.categories[selectedPointIndex],
    );
  }
}
